<template>
  <div>
    <div class="cropper-content">
      
      <div class="cropper-box">
        <!-- 剪裁框 -->
        <div class="cropper">
          <VueCropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :fixed-box="option.fixedBox"
            @real-time="realTime"
            :high="option.high"
            :info-true="option.infoTrue"
            :info="option.info"
            :max-img-size="option.maxImgSize"
          ></vueCropper>

          <div class="footer-btn">
            <!-- 缩放旋转按钮 -->
            <div class="scope-btn">
              <label class="btn" for="uploads">选择图片</label>
              <input
                type="file"
                id="uploads"
                style="position: absolute; clip: rect(0 0 0 0)"
                accept="image/png, image/jpeg, image/gif, image/jpg"
                @change="uploadImg($event, 1)"
                ref="uploadImg"
              />

              <ui-button type="primary" @click="changeScale(1)">+ 放大</ui-button>
              <!-- <el-button
                type="primary"
                icon="el-icon-zoom-in"
                @click="changeScale(1)"
              ></el-button> -->
              <ui-button type="primary" @click="changeScale(-1)">- 缩小</ui-button>
              <!-- <el-button
                type="primary"
                icon="el-icon-zoom-out"
                @click="changeScale(-1)"
              ></el-button> -->
            </div>
            
          </div>
        </div>
      </div>
      <div style="display:flex;flex-direction: column;">
        <!-- 预览框 -->
        <div class="show-preview" :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden',
							'margin': '5px 5px 5px 20px'}">
						<div :style="previews.div">
							<img :src="previews.url" :style="previews.img">
						</div>
				</div>
          
            <div class="footer-btn">
              <!-- 确认上传按钮 -->
              <div class="upload-btn">
                <ui-button type="primary" @click="uploadNewImage">上传</ui-button>
              </div>
            </div>
            </div>
    </div>

    <div style="text-align: left; color: red">
      鼠标滚轮放大缩小图片或点击+-按钮微调
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper"
//import {up} from '@/src/request/axios'
export default {
  components: {
    VueCropper,
  },
  props: {
    imgurl: {
      type: String,
      default: "",
    },
  },
  watch:{
    imgurl:function(v){
      this.option.img=window.URL.createObjectURL(new Blob('blob:'+v))
      // var reader = new FileReader();
      // reader.onload = (e) => {
      //   debugger
      //   let data;
      //   if (typeof e.target.result === "object") {
      //     // 把Array Buffer转化为blob 如果是base64不需要
      //     data = window.URL.createObjectURL(new Blob([e.target.result]))
      //   } else {
      //     data = e.target.result;
      //   }
      //   this.option.img = data;
      //   this.$refs.uploadImg.value = ""
      // }
      // // 转化为base64
      // // reader.readAsDataURL(file)
      // // 转化为blob
      // debugger
      // reader.readAsArrayBuffer('blob '+v)
    }
  },
  data() {
    return {
      previews: {}, // 预览数据
      option: {
        img: "", // 裁剪图片的地址  (默认：空)
        size: 0.6, // 裁剪生成图片的质量  (默认:1)
        full: true, // 是否输出原图比例的截图 选true生成的图片会非常大  (默认:false)
        outputType: "jpeg", // 裁剪生成图片的格式  (默认:jpg)
        canMove: true, // 上传图片是否可以移动  (默认:true)
        original: false, // 上传图片按照原始比例渲染  (默认:false)
        canMoveBox: true, // 截图框能否拖动  (默认:true)
        autoCrop: true, // 是否默认生成截图框  (默认:false)
        autoCropWidth: 300, // 默认生成截图框宽度  (默认:80%)
        autoCropHeight: 300, // 默认生成截图框高度  (默认:80%)
        fixedBox: true, // 固定截图框大小 不允许改变  (默认:false)
        high:true,
        infoTrue:false,
        info:true,
        maxImgSize:3000
      },
    };
  },
  created(){
  },
  activated(){
  },
  mounted(){
  },
  methods: {
    uploadImg(e, num) {
      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          this.option.img = data;
        } else if (num === 2) {
          this.example2.img = data;
        }
        this.$refs.uploadImg.value = "";
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    changeScale(num) {
      // 图片缩放
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft() {
      // 向左旋转
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      // 向右旋转
      this.$refs.cropper.rotateRight();
    },
    // Update () {
    //   // this.file = this.imgFile
    //   this.option.img = this.imgFile
    // },
    realTime(data) {
      // 实时预览
      this.previews = data;
      console.log("预览图片数据", this.previews);
    },
    uploadNewImage(){
      let self=this
      // const loading = this.$loading({
      //     target:'.cropper-content',
      //     lock: true,
      //     text: '正在裁剪',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // });
      // this.$refs.cropper.getCropData(data => {
      //   // do something
      //   console.log(data)  
      // })
      this.$refs.cropper.getCropBlob((data) => {
          //loading.setText('正在上传')
          // open a full screen mask with default text: 'Loading...'
          const key = this.$dlg.mask('正在上传')
          // do some request from server side
          this.$http.up({file:data}).then(res=>{
            self.$dlg.close(key)
            //loading.close()
            if(!res.IsPositive) {
              self.$dlg.toast('上传失败',{messageType:'error'})
              return
            }
            self.$emit('upload_success',res)
            
          })
      })
    },
    upload(type) {
      // 将剪裁好的图片回传给父组件
      event.preventDefault();
      let that = this;
      if (type === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          that.$emit("upload", data);
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          that.$emit("upload", data);
        });
      }
    },
  }
};
</script>

<style lang="scss" scope>
img{
  max-width: initial!important;
}
.cropper-content {
  display: flex;
  justify-content: space-between;
  width:100%;
  .cropper-box{
    width: 400px;
      height: 400px;
    .cropper {
      width: 400px;
      height: 400px;
    }
  }
  .show-preview {
    flex: 1;
    display: flex;
    justify-content: center;
    align-self: flex-end;
    min-width:300px;
    min-height: 300px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC);
    .preview {
      overflow: hidden;
      border: 1px solid #cccccc;
      background: #cccccc;
    }
  }
  .footer-btn {
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    .scope-btn {
      width: 250px;
      display: flex;
      justify-content: space-around;
    }
    .upload-btn {
      flex: 1;
      display: flex;
      justify-content: center;
    }
    .btn {
      outline: none;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 3px;
      color: #fff;
      background-color: #66b1ff;
      border-color: #66b1ff;
    }
  }
}
</style>